import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "m-t-20 m-b-20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }

import {ref, watch} from "vue";
import {useApp, useImage} from "@hview/hview-vue3/packages/hooks";
import {certificationApproveApi, getCertificationInfoApi, getProjectListApi, getTeamListByProjectApi} from "@/api/kh";
import {Notice} from "@hview/hview-vue3/packages";

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: "AuditDialog",
  
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["on-load"],
  setup(__props, { expose: __expose, emit: __emit }) {

const {visible, loading} = useApp();
const {getImagePath} = useImage();
const emits = __emit;

/**
 * 审核意见ref
 */
const reasonRef = ref();

const modelType: string = ref("");

/**
 * 表单ref
 */
const formRef = ref();

/**
 *  步骤条选中
 */
const stepActive = ref(0);
const model = ref({
  id: "",
  status: "",
  projectId: "",
  reason: "",
  teamId: ""
});

/**
 * @description 审核图片
 */
const auditImages = ref([]);

/**
 * @description 监听审核状态变化
 */
watch(() => model.value.status, (value: string) => {
  if (value !== "rejected") {
    reasonRef.value.clearValidate();
  }
});

watch(visible, (value: boolean) => {
  if (!value) {
    if (formRef.value) {
      formRef.value.resetFields();
    }
    stepActive.value = 0;
  }
});

/**
 * 校验规则
 */
const rules = ref({
  projectId: [{ required: true, message: "请选择项目", trigger: "change" }],
  teamId: [{ required: true, message: "请选择中心", trigger: "change" }],
  status: [{ required: true, message: "请选择状态", trigger: "change" }]
});

/**
 * 详细信息
 */
const info = ref({
});

/**
 * @description 提交数据至后台
 */
const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      loading.value = true;
      certificationApproveApi(model.value).then(() => {
        Notice.success("提交成功");
        visible.value = false;
        emits("on-load");
      }).finally(() => {
        loading.value = false;
      })
    }
  });
}

/**
 * 项目列表
 */
const projectList = ref([]);

/**
 * 小组列表
 */
const teamList = ref([]);

/**
 * @description 获取team列表
 */
const getTeamList = () => {
  getTeamListByProjectApi({projectId: model.value.projectId}).then((res: any) => {
    const {data} = res;
    teamList.value = data;
  });
}

const selectEvent = () => {
  model.teamId = "";
  getTeamList();
}

/**
 * @description 加载详情
 */
const load = () => {
  loading.value = true;
  Promise.all([getCertificationInfoApi(model.value), getProjectListApi()]).then((arr: any[]) => {
    const certificationInfo = arr[0].data;
    model.value.projectId = certificationInfo.kh_project_id;
    if (model.value.projectId) {
      getTeamList();
    }
    const project = arr[1].data;
    info.value = certificationInfo;
    const splitImage = certificationInfo.images.split(",");
    auditImages.value = [];
    splitImage.forEach((item: string) => {
      auditImages.value.push(getImagePath(item));
    });
    projectList.value = project;
  }).finally(() => {
      loading.value = false;
  });
}

/**
 * @description 打开弹窗
 */
const open = (id: string, type: string) => {
  model.value.id = id;
  visible.value = true;
  modelType.value = type;
  load();
}


__expose({
  open
});

return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_h_text = _resolveComponent("h-text")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_h_dict = _resolveComponent("h-dict")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    title: modelType.value == 'audit' ? '审核' : '审核详情',
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: "750"
  }, {
    footer: _withCtx(() => [
      (modelType.value == 'audit')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_button, {
              link: "",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (visible.value = false))
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            (stepActive.value == 1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (stepActive.value = 0))
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("上一步")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (stepActive.value == 1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  loading: _unref(loading),
                  onClick: submit
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("提交")
                  ])),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            (stepActive.value == 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  type: "primary",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (stepActive.value = 1))
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("下一步")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("关闭")
            ])),
            _: 1
          }))
    ]),
    default: _withCtx(() => [
      (modelType.value == 'audit')
        ? (_openBlock(), _createBlock(_component_el_steps, {
            key: 0,
            style: {"width":"100%"},
            active: stepActive.value,
            "align-center": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_step, { title: "基础信息" }),
              _createVNode(_component_el_step, { title: "审核" })
            ]),
            _: 1
          }, 8, ["active"]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (stepActive.value == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_descriptions, {
                column: 2,
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "真实姓名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_h_text, {
                        modelValue: info.value.realname,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((info.value.realname) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "昵称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_h_text, {
                        modelValue: info.value.nickname,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((info.value.nickname) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "所属单位" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_h_text, {
                        modelValue: info.value.qq,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((info.value.qq) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "所属科室" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_h_text, {
                        modelValue: info.value.works,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((info.value.works) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "擅长领域" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_h_text, {
                        modelValue: info.value.intro,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((info.value.intro) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "工作年限" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_h_text, {
                        modelValue: info.value.ability,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((info.value.ability) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    span: 2,
                    label: "审核状态"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_h_dict, {
                        modelValue: info.value.status,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((info.value.status) = $event)),
                        mode: "text",
                        dictKey: "audit_type"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (info.value.memo)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 0,
                        span: 2,
                        label: "审核意见"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(info.value.memo), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_descriptions_item, { label: "审核图片" }, {
                    default: _withCtx(() => [
                      (auditImages.value.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(auditImages.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_image, {
                              fit: "contain",
                              key: index,
                              class: "w-100 h-100 m-r-5",
                              "preview-src-list": auditImages.value,
                              src: item
                            }, null, 8, ["preview-src-list", "src"]))
                          }), 128))
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, "暂无内容"))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (stepActive.value == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_form, {
                ref_key: "formRef",
                ref: formRef,
                onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_,
                "label-width": "auto",
                model: model.value,
                rules: rules.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "关联项目",
                    prop: "projectId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        onChange: selectEvent,
                        modelValue: model.value.projectId,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((model.value.projectId) = $event)),
                        placeholder: "请选择项目"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectList.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.project_name,
                              value: item.id,
                              key: index
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (model.value.projectId)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "中心",
                        prop: "teamId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: model.value.teamId,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((model.value.teamId) = $event)),
                            placeholder: "请选择中心"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamList.value, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.name,
                                  value: item.id,
                                  key: index
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "审核",
                    prop: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: model.value.status,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((model.value.status) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_h_dict, { dictKey: "audit_type_edit" })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    ref_key: "reasonRef",
                    ref: reasonRef,
                    onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_,
                    label: "审核意见",
                    prop: "reason",
                    rules: {
            required: model.value.status == 'rejected' ? true : false,
            message: '请输入审核意见',
            trigger: ['blur', 'change'],
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: model.value.reason,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((model.value.reason) = $event)),
                        rows: "4",
                        placeholder: "请输入审核意见"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["onVnodeBeforeMount", "rules"])
                ]),
                _: 1
              }, 8, ["onVnodeBeforeMount", "model", "rules"])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _unref(loading)]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})